import { Types } from './tipoAcao';

export const setTipoAcao = (tipoAcao) => ({
  type: Types.SET_TIPO_ACAO,
  payload: tipoAcao,
});